var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeries1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6a4925;\n      }\n\n      .cls-2 {\n        fill: #e3ac6b;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -1.23,
    y: -0.7,
    width: 60.49,
    height: 59.89
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.57,16.59h-4.94v-2.47c0-.34-.28-.62-.62-.62s-.62.28-.62.62v2.47h-14.81v-2.47c0-.34-.28-.62-.62-.62s-.62.28-.62.62v2.47h-4.94c-1.02,0-1.85.83-1.85,1.85v22.21c0,1.02.83,1.85,1.85,1.85h27.15c1.02,0,1.85-.83,1.85-1.85v-22.21c0-1.02-.83-1.85-1.85-1.85ZM14.81,18.44c0-.34.28-.62.62-.62h4.94v2.47c0,.34.28.62.62.62s.62-.28.62-.62v-2.47h14.81v2.47c0,.34.28.62.62.62s.62-.28.62-.62v-2.47h4.94c.34,0,.62.28.62.62v6.17H14.81v-6.17ZM43.19,40.65c0,.34-.28.62-.62.62H15.43c-.34,0-.62-.28-.62-.62v-14.81h28.38v14.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.63,38.77c.12.12.28.18.44.18s.32-.06.44-.18l4.5-4.5,4.5,4.5c.12.12.28.18.44.18s.32-.06.44-.18c.24-.24.24-.63,0-.87l-4.5-4.5,4.5-4.5c.24-.24.24-.63,0-.87s-.63-.24-.87,0l-4.5,4.5-4.5-4.5c-.24-.24-.63-.24-.87,0s-.24.63,0,.87l4.5,4.5-4.5,4.5c-.24.24-.24.63,0,.87Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeries1);
export default __webpack_public_path__ + "static/media/Feries (1).90648e16aa1a55d5ff52bace9061ac3c.svg";
export { ForwardRef as ReactComponent };